import { Component, Input } from '@angular/core';

@Component({
    selector: 'wf-lockout-message',
    templateUrl: './lockout-message.component.html',
    styleUrl: './lockout-message.component.css',
    standalone: false
})
export class LockoutMessageComponent {
  @Input() locked: boolean = false ;
  @Input() attempts: number = 0 ;
  @Input() duration: number = 0 ;
  @Input() attemptsRemaining: number = 0 ;
}
